import { createRoute } from "./utils"

const publicRoutes = {
	base: createRoute(`/`),
	products: createRoute(`/`),
	product: createRoute(
		`/product/:handle`,
		(handle: string) => `/product/${handle}`,
	),
	contact: createRoute(`/contact`),
	about_us: createRoute(`/about-us`),
	care_tips: createRoute(`/patchwork/care-tips`),
	cart: createRoute(`/cart`),

	auth_login: createRoute(`/login`),
	auth_register: createRoute(`/signup`),
	auth_forgot_password: createRoute(`/forgot-password`),

	privacy_policy: createRoute(`/privacy`),
	cookie_policy: createRoute(`/cookies`),
	legal_notice: createRoute(`/legal`),
}

export default publicRoutes
